import React from 'react';
import styles from './postBody.module.css'
import PostImagesContainer from "../PostImagesContainer/PostImagesContainer";
import {observer} from "mobx-react-lite";

const PostBody = observer(({data, index, compact = false, showText = true}) => {
    return (
        <div className={compact ? styles.compact : undefined}>
            <h2 className={styles.title}>{data.header}</h2>
            <div className={styles.imageContainer}>
                <PostImagesContainer index={index} post={data} />
            </div>

            {showText && (
                <div className={styles.newsText}>
                    {data.text}
                </div>
            )}
        </div>
    );
});

export default PostBody;
